import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { positionDropdown } from '../../../../../common/dropdown'
import { Element } from '../../../../../common/html/element'
import { SelectCurrencyUnit } from '../../../../../common/selectCurrencyUnit'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { SelectCustom } from '../../../../../common/selectCustom'
import { FORMAT, formatDateTime } from '../../../../../helpers/datetime'
import { Filter } from '../../../../common/header/filterBar'
import { PERIOD_TYPE_DATA } from '../../constant'
import {
  changePeriodType,
  getHighlightScore,
  selectTypePeriod,
} from '../../store/slice'
import classes from './index.module.scss'

export const StickyComponent = () => {
  const dispatch = useDispatch()

  const lastUpdate = useSelector(getHighlightScore('performancePublicDate'))
  const timeFrequency = useSelector(selectTypePeriod)
  const locale = useSelector((state) => state.i18n.locale)

  const handleChooseItem = (item) => {
    dispatch(changePeriodType(item.value))
  }

  const renderLeft = () => {
    return (
      <div className={classes.contentLeft}>
        <div>
          <Element elementName="p" style={{ lineHeight: '16px' }}>
            <Translate value="score.main.LAST_UPDATE_DATE" />
            <Element elementName="span" style={{ paddingLeft: 2 }}>
              {formatDateTime(lastUpdate, FORMAT.DATE, locale)}
            </Element>
          </Element>
        </div>
        <Element
          className={classes.border}
          style={{ backgroundColor: '#9C9C9C' }}
        />
        <div className={classes.period}>
          <Element elementName="p" style={{ lineHeight: '16px' }}>
            <Translate value="score.main.PERIOD" />
          </Element>
          <SelectCustom
            style={{
              marginLeft: 8,
            }}
            position={positionDropdown.BOTTOM_END_LEFT}
            activeItem={PERIOD_TYPE_DATA.find(
              (item) => item.value === timeFrequency,
            )}
            data={PERIOD_TYPE_DATA}
            chooseItem={handleChooseItem}
            isI18n
          />
        </div>
      </div>
    )
  }

  const renderRight = () => <SelectCurrencyUnit screen={SCREEN.SCORE} />

  return <Filter renderLeft={renderLeft} renderRight={renderRight} />
}
